import { makeActionCreator } from '../../config/store/utils'
import { getSectorPurchasingMechanisms } from '../../services/sectors'

export const GET_PROVIDERS = 'GET_PROVIDERS'
export const GET_PROVIDERS_ERROR = 'GET_PROVIDERS_ERROR'
export const GET_PROVIDERS_SUCCESS = 'GET_PROVIDERS_SUCCESS'
export const onGetProviders = makeActionCreator(GET_PROVIDERS)
export const onGetProvidersError = makeActionCreator(GET_PROVIDERS_ERROR, 'payload')
export const onGetProvidersSuccess = makeActionCreator(GET_PROVIDERS_SUCCESS, 'payload')
export const onGetProvidersThunk = payload => async dispatch => {
  dispatch(onGetProviders())

  try {
    const { data = {} } = await getSectorPurchasingMechanisms({
      proccessId: payload.proccessId,
      year: payload.year,
      sectorId: payload.sectorId
    })
    const enhancedData = data.payload
      ?.sort((a, b) => b.amountCLP > a.amountCLP)
      .map(datum => ({
        amountCLP: datum.amountCLPAnual,
        amountUSD: datum.amountUSDAnual,
        biddings: datum.qtyProcess,
        dni: datum.rutProvider,
        name: datum.provider,
        orders: datum.qtyProcess,
        percentage: datum.percentage,
        year: datum.year
      }))
    enhancedData.sort((a, b) => b.amountCLP - a.amountCLP)
    const categories = enhancedData.map(datum => datum.name)
    const csv = [
      ['Año', 'Proveedor', 'RUT proveedor', 'Monto total', 'Monto total (USD)', 'Nº de órdenes de compra'],
      ...enhancedData.map(datum => [
        payload.year,
        datum.name,
        datum.dni,
        datum.amountCLP,
        datum.amountUSD,
        datum.biddings
      ])
    ]
    const csvTableTender = [
      ['Año', 'Proveedor', 'RUT proveedor', 'Nº de órdenes de compra'],
      ...enhancedData.map(datum => [payload.year, datum.name, datum.dni, datum.biddings])
    ]
    return dispatch(onGetProvidersSuccess({ categories, csv, csvTableTender, data: enhancedData }))
  } catch (error) {
    return dispatch(onGetProvidersError({ error }))
  }
}
